import React from "react";
import { styled } from "@mui/system";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const DAYS = [
  {
    key: "1",
    label: "S",
  },
  {
    key: "2",
    label: "M",
  },
  {
    key: "3",
    label: "T",
  },
  {
    key: "4",
    label: "W",
  },
  {
    key: "5",
    label: "T",
  },
  {
    key: "6",
    label: "F",
  },
  {
    key: "7",
    label: "S",
  },
];

// ToggleButtonGroup
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  display: "flex",
}));

// ToggleButton 
const StyledToggle = styled(ToggleButton)(({ theme }) => ({
  color: "#00AB55",
  borderRadius: "50%",
  width: 30,
  height: 30,
  background: "#F1F1F1",
  marginRight: "10px",
  "&.Mui-selected": {
    color: "white",
    background: "#00AB55",
  },
  "&:hover": {
    background: "#EBF8F2",
    color: "#00AB55",
  },
  "&.Mui-selected:hover": {
    background: "#007c3c",
    borderColor: "#007c3c",
    color: "white",
  },
  textTransform: "unset",
  fontSize: "0.75rem",
}));

export default function ToggleWeekDays({ days, setDays }) {
  return (
    <div className="week-select-buttons">
      <StyledToggleButtonGroup
        size="small"
        aria-label="Days of the week"
        value={days}
        onChange={(event, value) => setDays(value)}
      >
        {DAYS.map((day, index) => (
          <StyledToggle key={day.key} value={index} aria-label={day.key}>
            {day.label}
          </StyledToggle>
        ))}
      </StyledToggleButtonGroup>
    </div>
  );
}
